<div class="p-grid" style="margin: 15px;">
     <!-- DETAILS MODERATION -->
    <p-panel [toggleable]="false"  [showHeader]="true" class="p-col-12" styleClass="details">
        <p-header>
            <div class="p-grid">
                <div class="p-col-12" style="margin-bottom: 15px;">
                    <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">HISTORIQUE DES ACTIONS</span>
                </div>             
            </div>

            <div class="p-grid">
                <div class="p-col-5 p-lg-2 p-xl-2" style="text-align: left; color: black;"> Historique du </div>
                
                <div class="p-col-7 p-lg-2 p-xl-2">
                    <p-calendar class="ui-fluid" [locale]="fr" [maxDate]="maxDate" [(ngModel)]="dateDebut" [readonlyInput]="true" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'"></p-calendar>
                </div>

                <div class="p-col-2 p-lg-2 p-xl-2" style="text-align: center; color: black;"> au </div>
                
                <div class="p-col-7 p-sm-offset-spec p-lg-2 p-xl-2 ">
                    <p-calendar class="ui-fluid" [locale]="fr" [maxDate]="maxDate" [(ngModel)]="dateFin" [readonlyInput]="true" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'"></p-calendar>
                </div>

                <div class="p-col-12 p-lg-3 p-xl-3">
                    <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 85%;" icon="pi pi-search" label="Rechercher" (click)="rechercherHistorique(dateDebut, dateFin)" ></p-button>
                </div>

                <div class="p-col-12" *ngIf="isAdmin()">
                    <div class="p-col-12 p-lg-2 p-xl-2">
                        <p-dropdown *ngIf="canSelectUsers()" [style]="{'width':'100%'}" [options]="historiqueUserFilter" [(ngModel)]="selectedUserOption" appendTo="body" placeholder="Choisissez une option"></p-dropdown>
                    </div>
                    <div class="p-col-12 p-lg-2 p-xl-2">
                        <p-dropdown  [style]="{'width':'100%'}" [options]="historiqueFilter" [(ngModel)]="selectedOption" appendTo="body" placeholder="Choisissez une option"></p-dropdown>
                    </div> 
                </div>
            </div>
        </p-header>
    </p-panel>
    <!-- FIN DETAILS MODERATION -->

    <!-- TABLEAU HISTORIQUE -->
    <div style="min-width: 100%;" class="overflow-container">
        <p-table #dt 
            [columns]="cols" 
            [value]="listeHistorique" 
            [paginator]="true" [rows]="10" 
            [showCurrentPageReport]="true" styleClass="ui-table-customers" 
            currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes" 
            [rowsPerPageOptions]="[10,25,50]"
            [loading]="loading"
            [rowHover]="true"
        >
    
            <ng-template pTemplate="caption">
                <div style="text-align: right ; margin: 2.5px auto;">
                    
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"  [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>
                    <th>Détails</th>
                </tr>
                <tr>
                    <th *ngFor="let col of cols" [ngSwitch]="col.field">
                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'designation_type_ptl'" [style]="{'width':'100%'}" [options]="typeFilter" defaultLabel="Tous les types" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                        
                        <input *ngSwitchCase="'num_point_accueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">

                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'id_complexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>

                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'designation_action'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="EtapeFilter" defaultLabel="Toutes les étapes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>

                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'statut'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="statutFilter" defaultLabel="Tous les etats" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>

                        <input *ngSwitchCase="'id_responsable'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">

                        <p-calendar *ngSwitchCase="'date_action'" [locale]="fr" [appendTo]="'body'" [maxDate]="dateFin" [minDate]="dateDebut" (onSelect)="onDateSelect($event)" (onClearClick)="dt.filter('', 'date_action', 'equals')" [showButtonBar]="true" styleClass="ui-column-filter" placeholder="Filtrer la date" [readonlyInput]="true" dateFormat="dd/mm/yy" ></p-calendar>
                    </th>

                    <th></th>
                </tr>
            </ng-template>
        
            <ng-template pTemplate="body" let-historique let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" style="text-align: center;" >
                        <ng-template [ngIf]="col.field === 'duree_action'">
                            <span [class]="checkDuree(historique)">
                                {{ convertToIso(historique[col.field]) }}
                            </span>
                            <span style="padding-left: 5px;">
                                ({{ getDmtIso(historique.id_complexite) }})
                            </span>
                        </ng-template>
                        <ng-template [ngIf]="col.field === 'id_complexite'">
                            <span>
                                {{ getComplexite(historique[col.field]) }}
                            </span>
                        </ng-template>
                        <ng-template [ngIf]="col.field !== 'duree_action' && col.field !== 'id_complexite'" > 
                            <span [class]="(col.field === 'statut' && historique[col.field] !== '') ? ((historique[col.field] === 'KO' ) ? 'customer-badge status-unqualified' : 'customer-badge status-qualified' ) : ''">
                                {{historique[col.field]}}
                            </span>

                        </ng-template>
                    </td>
                    
                    <td align="center"> <p-button *ngIf=" detailsClickable(historique['id_action']) "  type="button"  icon="pi pi-info-circle"  class="btn-info" (click)="voirDetails(historique['id_historique'] )" ></p-button> </td>
                
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                </tr>
            </ng-template>
            
        </p-table>
    </div>
    <!-- FIN TABLEAU HISTORIQUE -->

</div>